import React from "react";
import { Link } from "react-router-dom";
// reactstrap components
import {
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  FormGroup,
  InputGroupAddon,
  InputGroupText,
  Input,
  InputGroup,
  Navbar,
  Nav,
  Container,
  Media
} from "reactstrap";

import { getSessionCookie,setObjectCookie, setObjectCookie_Generic} from "services/session.js";

import routes from "routes.js";

class AdminNavbar extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      value:'', 
      nomeUsuario: getSessionCookie().nome + " (" + getSessionCookie().perfil + ")",
      icon: ""
    }
    this.handleEnter = this.handleEnter.bind(this);
  } 

  handleEnter = (e) => {
    const { history } = this.props;
    if (e.key === "Enter") {
      if(e.target.value !== ""){
        setObjectCookie_Generic("codigo_device", {codigo: e.target.value});
      }else{
        setObjectCookie_Generic("codigo_device", {codigo: "*"});
      }
      this.state.value = "";
      history.push('/admin/load');
      setTimeout(() => { history.push('/admin/consultadispositivo'); }, 1);
    }
  };

  LogOut = () => {
    const { history } = this.props;
    history.push('/auth/login');
  };

  SMTP = () => {
    const { history } = this.props;
    history.push('/admin/smtp');
  };

  render() {

    var _name_route = this.props.brandText;
    
    return (
      <>
        <Navbar className="navbar-top navbar-dark" expand="md" id="navbar-main">
          <Container fluid>
            <span class="h4 mb-0 text-white text-uppercase d-none d-lg-inline-block">
              <i className={routes.filter(function (n){ return n.name === _name_route })[0].icon}></i>
              &nbsp;
              {this.props.brandText}
            </span>
            <div class="navbar-search navbar-search-dark form-inline mr-3 d-none d-md-flex ml-lg-auto">
              <FormGroup className="mb-0">
                <InputGroup className="input-group-alternative">
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="fas fa-search" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input 
                    placeholder="Pesquisar Shield / Dispositivo" 
                    type="text"
                    onKeyDown={this.handleEnter}
                  />
                </InputGroup>
              </FormGroup>
            </div>
            <Nav className="align-items-center d-none d-md-flex" navbar>
              <UncontrolledDropdown nav>
                <DropdownToggle className="pr-0" nav>
                  <Media className="align-items-center">
                    <Media className="ml-2 d-none d-lg-block">
                      <span className="mb-0 text-sm font-weight-bold">
                        {this.state.nomeUsuario}
                      </span>
                      &nbsp;
                      <i class="fa fa-chevron-circle-down" aria-hidden="true"/>
                    </Media>
                  </Media>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-arrow" right>
                  <DropdownItem className="noti-title" header tag="div">
                    <h6 className="text-overflow m-0">Bem Vindo!</h6>
                  </DropdownItem>
                  <DropdownItem onClick={this.SMTP}>
                    <i className="ni ni-settings-gear-65" />
                    <span>Configurações</span>
                  </DropdownItem>
                  <DropdownItem divider />
                  <DropdownItem onClick={this.LogOut}>
                    <i className="ni ni-user-run" />
                    <span>Logout</span>
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            </Nav>
          </Container>
        </Navbar>
      </>
    );
  }
}

export default AdminNavbar;
